// Period projection of server-calculated realizations. Lifetime group data stays intact.
const day = value => String(value || '').slice(0, 10);
const inRange = (value, from, to) => !!value && (!from || day(value) >= from) && (!to || day(value) <= to);

export function journalEvents(group) {
  if (Array.isArray(group.realized_events)) return group.realized_events;
  if (group.status === 'OPEN') return [];
  return [{
    date: group.close_date || group.open_date,
    amount_base: group.return_amount_base,
    commissions_base: group.commissions_base,
  }];
}

export function journalPerformance(group) {
  const events = journalEvents(group);
  if (!events.length || events.some(event => event.amount_base == null || event.commissions_base == null)) {
    return { net: null, commissions: null };
  }
  return {
    net: events.reduce((sum, event) => sum + Number(event.amount_base), 0),
    commissions: events.reduce((sum, event) => sum + Number(event.commissions_base), 0),
  };
}

export function projectJournalGroup(group, from, to, basis = 'close') {
  const events = journalEvents(group);
  let selected;
  if (basis === 'open') {
    if ((from || to) && !inRange(group.open_date || group.close_date, from, to)) return null;
    selected = events.map(event => ({ ...event, bucket_date: group.open_date || event.date }));
  } else {
    selected = events.filter(event => inRange(event.date, from, to));
    if ((from || to) && !selected.length
      && (events.length || group.status !== 'OPEN' || !inRange(group.open_date, from, to))) return null;
    selected = selected.map(event => ({ ...event, bucket_date: event.date }));
  }
  const result = { ...group, realized_events: selected };
  const { net } = journalPerformance(result);
  if (net != null && !['OPEN', 'ASSIGNED'].includes(group.status)) {
    result.status = net > .005 ? 'WIN' : (net < -.005 ? 'LOSS' : 'BREAKEVEN');
  }
  return result;
}
